module.exports = __webpack_public_path__ + "img/no-dossiers.80d81666.svg";